import { ChangeDetectionStrategy, Component, effect, Injector, untracked, ViewEncapsulation } from '@angular/core';
import { FiInfiniteScrollDataSource } from '@fi-shared/fi-items-list/fi-infinite-scroll-data-source';
import { IOnboardingActive } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding';
import { FiItemsListType } from '@fi-app/shared/fi-items-list/fi-items-list-type';
import { ObjectTypes } from '@fi-app/shared/types';
import { FiTooltipContentType } from '@fi-shared/fi-tooltip/fi-tooltip-enums';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiOnboardingActiveDataService } from '@fi-app/fi-onboarding/fi-onboarding-active/fi-onboarding-active-data.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-system-notifications-onboardings',
    templateUrl: './fi-system-notifications-onboardings.component.html',
    styleUrl: './fi-system-notifications-onboardings.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-system-notifications-onboardings' },
    standalone: false,
})
export class FiSystemNotificationsOnboardingsComponent extends FiInfiniteScrollDataSource<IOnboardingActive> {
    defaultSortColumnName = 'CompletedFraction';
    itemsListType: FiItemsListType = FiItemsListType.OnboardingListItems;
    objectType: ObjectTypes = ObjectTypes.Onboarding;

    constructor(
        injector: Injector,
        private fiStateService: FiStateService,
        private fiOnboardingActiveDataService: FiOnboardingActiveDataService,
    ) {
        super(injector, {});
    }

    todoOnboardingsEffect = effect(() => {
        const todoOnboardings = this.fiOnboardingActiveDataService.todoOnboardings();
        this.reloadData();
    });

    getListData(): Promise<IOnboardingActive[]> {
        return Promise.resolve(this.fiOnboardingActiveDataService.todoOnboardings());
    }

    protected readonly FiTooltipContentType = FiTooltipContentType;

    onRowClick(item: IOnboardingActive) {
        this.fiStateService.go(FiStateNames.Onboarding.Completion, {
            id: item.Id,
        });
    }

    protected readonly FiStateNames = FiStateNames;
}
